// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"379b82a6","875":"6351243a"}[chunkId] + ".chunk.js";
};